import { getDiscount, getTotal } from ".";


const gTagPurchaseEvent = (order, discount = 0) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') { 
      window.gtag('event', 'conversion', {
          'send_to': 'AW-17913764752/PURCHASE_LABEL',
          'value': (getTotal(order)- getDiscount(order, false, discount)).toFixed(2),
          'currency': 'USD',
          'transaction_id': order.orderID 
      });
    }
}
const gTagDocumentUploadEvent = () => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') { 
        window.gtag('event', 'begin_checkout', {
            'send_to': 'AW-17913764752/BEGIN_CHECKOUT_LABEL',
            'value': 24.95, // Standard page price
            'currency': 'USD'
          });
    }
}

export { gTagPurchaseEvent, gTagDocumentUploadEvent };
